import { useAutoSave as useAutoSaveContext } from '../contexts/AutoSaveContext';

export const useAutoSave = () => {
  return useAutoSaveContext();
};